export const LOADING = "loader";
export const LANGUAGE = "language";
export const SHOW_GLOBE = "show_globe";
export const SET_LOCATION = "SET_LOCATION";
